import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { getAllInsuranceDataForOrder } from "../../../../shared/api/bigQuery/nycbsPharmaOrders";
import {
  InsuranceDetailsModel,
  mapToInsuranceDetailsModel,
} from "../../../data-model/insuranceDetails";
import { logDataToConsole } from "../../../utils/customLogger";

interface InsuranceDetailsSlice {
  data: InsuranceDetailsModel[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: InsuranceDetailsSlice = {
  data: null,
  loading: false,
  error: null,
};

const insuranceDetailsSlice = createSlice({
  name: "insuranceDetails",
  initialState,
  reducers: {
    setInsuranceDetails: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.data = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetInsuranceDetails(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export default insuranceDetailsSlice.reducer;

const getIsLoading = (
  getState: () => { insuranceDetails: InsuranceDetailsSlice },
) => {
  return getState().insuranceDetails.loading;
};

export const fetchAllInsuranceDetailsForOrder =
  (id: string) => async (dispatch: Dispatch, getState: any) => {
    if (getIsLoading(getState)) {
      return;
    }
    dispatch(insuranceDetailsSlice.actions.setLoading());
    try {
      const response = await getAllInsuranceDataForOrder(id);
      const insuranceData = response.details.map((insurance) =>
        mapToInsuranceDetailsModel(insurance),
      );
      logDataToConsole("prescriptionData", insuranceData);
      dispatch(
        insuranceDetailsSlice.actions.setInsuranceDetails(insuranceData),
      );
    } catch (error: unknown) {
      let errorMessage = "An unexpected error occurred";
      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === "string") {
        errorMessage = error;
      } else if (error && typeof error === "object" && "message" in error) {
        errorMessage = String(error.message);
      }
      dispatch(insuranceDetailsSlice.actions.setError(errorMessage));
    }
  };

export const resetInsuranceDetails = () => (dispatch: Dispatch) => {
  dispatch(insuranceDetailsSlice.actions.resetInsuranceDetails());
};
